/**
 * Normalizes an admin-entered website URL, returning null when it is not a usable http(s) address.
 *
 * A bare domain is accepted and gets an `https://` prefix, since that is what reps type. Anything
 * that already carries a scheme must be http or https: this value is persisted to the account and
 * rendered as a navigable link elsewhere in admin, so a `javascript:` or `data:` value would be
 * stored XSS. (See the `isSafeHttpUrl` guards on the account detail Overview cards, which defend
 * the render side of the same field.)
 */
export function normalizeWebsiteUrl(value: string): string | null {
	const trimmed = (value ?? '').trim();
	if (!trimmed) return null;

	const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed);
	try {
		const url = new URL(hasScheme ? trimmed : `https://${trimmed}`);
		return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
	} catch {
		return null;
	}
}
